import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import '../../sass/main.scss';
import '../utils/font-awesome';

import favicon from '../assets/images/favicon.ico';
import Header from '../components/header';
import Footer from '../components/Footer';
import DriftWidget from '../components/DriftWidget';

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      titleTemplate="%s | RadonEasy"
      title="Professional Radon Management Tool"
      meta={[
        { name: 'description', content: 'Management tool for professional radon testers. Automate test data entry, generate state-specific and consumer reports, worry-free quality assurance with notifications about expiring devices and duplicates, spikes and cross-check entries.' },
      ]}
      link={[
        { rel: 'shortcut icon', href: favicon },
      ]}
      script={[
        { type: 'text/javascript', src: 'https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js' },
      ]}
    />
    <Header siteTitle={data.site.siteMetadata.title} />
    <DriftWidget />
    <div>
      {children()}
    </div>
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.func,
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js